export default function () {
  const widgetName = 'bhssBlurryImage';
  const widgetOpts = bhssBlurryImageOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.buttonwrap').remove();
        $(this).find('.card-content').remove();
        $('#heroBanner').css('background-image', `url('${data.items[x].ImageWithPath}')`);
        $('#heroBanner').append('<div class="blurEffect"></div>');

      })

      if (data.items.length <= 0) {
        $(body).addClass('no-hero-image');
        $('#heroBanner').remove();
        $(`#${widgetName}`).remove();
        $('.content').removeClass('custom-slider-active');
      } else {
        $(body).addClass('hero-image');
        $(`#${widgetName}`).remove();
     
      }

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}